import { ListParams, ListResponse } from 'models';
import { alarmInfo } from 'models/alarm';
import axiosClient from './axiosClient';

const urlApi = '/api/v1/alarm';
export const alarmApi = {
  fetchAlarmList(param: ListParams): Promise<ListResponse<alarmInfo>> {
    const url = `${urlApi}?entity_type=${param.type_Filter}&entity_id=${param.id}&page_size=${param._limit}&page=${param._page}&start_ts=${param.start_ts}&end_ts=${param.end_ts}&severity=${param.severity}&acknowledged_or_unacknowledged=${param.acknowledged_or_unacknowledged}&active_or_cleared=${param.active_or_cleared}`;
    return axiosClient.get(url);
  },
  fetchPropertiesAlarm(param: ListParams): Promise<string> {
    const url = `${urlApi}/${param.type}?alarm_id=${param.id}`;
    return axiosClient.put(url, {});
  },
};
